import script from "./ClientAuthUrlButton.vue?vue&type=script&setup=true&lang=js"
export * from "./ClientAuthUrlButton.vue?vue&type=script&setup=true&lang=js"

import "./ClientAuthUrlButton.vue?vue&type=style&index=0&id=41d5a750&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41d5a750"]])

export default __exports__